import { Button } from "@/components/ui/button";
import { useTextSize } from "@/hooks/useTextSize";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useI18n } from "@/lib/i18n";

const AccessibilityControls = () => {
  const { increase, decrease, level } = useTextSize();
  const { t } = useI18n();

  return (
    <div className="flex items-center gap-0.5">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 rounded-full text-xs font-bold"
            onClick={decrease}
            disabled={level <= 0}
            aria-label={t("a11y.decreaseText")}
          >
            A−
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t("a11y.decreaseTooltip")}</TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 rounded-full text-sm font-bold"
            onClick={increase}
            disabled={level >= 3}
            aria-label={t("a11y.increaseText")}
          >
            A+
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t("a11y.increaseTooltip")}</TooltipContent>
      </Tooltip>
    </div>
  );
};

export default AccessibilityControls;
